import { render, staticRenderFns } from "./alert-label.vue?vue&type=template&id=66ee88e2&scoped=true&"
import script from "./alert-label.vue?vue&type=script&lang=js&"
export * from "./alert-label.vue?vue&type=script&lang=js&"
import style0 from "./alert-label.vue?vue&type=style&index=0&id=66ee88e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee88e2",
  null
  
)

export default component.exports